type IconProps = { size?: number; color?: string };

/** Diagonal "go" arrow used inside buttons and links. */
export const ArrowIcon = ({ size = 14, color = "currentColor" }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 14 14" aria-hidden="true">
    <path
      d="M3 11 L11 3 M5 3 H11 V9"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MenuIcon = ({ open, size = 18 }: { open: boolean; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" aria-hidden="true">
    <path
      d={open ? "M4 4 L14 14 M14 4 L4 14" : "M2 5 H16 M2 9 H16 M2 13 H16"}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
